import React from 'react';

import {
  CaseStudySection,
  Footer,
  HeaderSection,
  QuotesSection,
  WorkForSection,
} from '../../components/parts';

export default function Home() {
  return (
    <div>
      <HeaderSection />
      <QuotesSection />
      <CaseStudySection />
      <WorkForSection />
      <Footer />
    </div>
  );
}
